import type { Board } from "../../board";
import { PRIORITY_DEFAULT, type ProcessableThing } from "../../interfaces";
import { Mob } from "../../mob";
import { Thing } from "../../thing";
import { Portal2 } from "../portal2/portal2";

export class NoThreatsAction extends Thing implements ProcessableThing {
	static key = "NoThreatsAction";
	private action: () => void;

	constructor(action: () => void = () => {}) {
		super();
		this.action = action;
	}

	processTurn(board: Board): void {
		const hasThreats = board.getPhysicalThings().some((t) => t instanceof Mob || t instanceof Portal2);
		if (!hasThreats) {
			this.action();
			board.removeAtEndOfTurn(this);
		}
	}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	static deserialize(_data: any): NoThreatsAction {
		return new NoThreatsAction();
	}
}
